<template>
  <div class="rebeta" v-show="rebetaData">
    <div class="rc">
      <div class="clsoe" @click="hideRebeta()">
        <img src="@/assets/close.png" />
      </div>
      <h1>领取返利</h1>
      <!-- 个人总额 -->
      <div class="amountPersonal">
        <div class="amount">
          截至目前您的充值总额为：<i>{{ person }}元</i>
        </div>
        <div class="gift" v-if="showPersonGift">
          根据活动规则，您没有获得的返利礼包哦
        </div>
        <div class="gift" v-else>
          根据活动规则，您获得的返利礼包为：<i>{{ personGiftName }}</i>
        </div>
        <div class="pc">
          <div class="box box-left" v-if="personGiftIsTure">
            <div class="process" v-for="(item, i) in personGift" :key="i">
              <div
                class="plan planHide"
                :class="personGift[i].status ? 'on' : ''"
              ></div>
              <div class="gp">
                <span>
                  <img :src="item.img_url" />
                </span>
                <p>{{ item.gift_name }}</p>
              </div>
            </div>
          </div>
          <div class="box" v-else>
            <div class="process" v-for="(item, i) in personGift" :key="i">
              <div
                class="plan"
                v-if="personGift.length == 1"
                :class="personGift[i].status ? 'on' : ''"
              ></div>
              <div
                class="plan planHide"
                v-else-if="
                  personGift.length == 3 &&
                  personGift.slice(-2)[0].status == true
                "
                :class="personGift[i].status ? 'on' : ''"
              ></div>
              <div
                class="plan"
                v-else
                :class="personGift[i].status ? 'on' : ''"
              ></div>
              <div class="gp">
                <span>
                  <img :src="item.img_url" />
                </span>
                <p>{{ item.gift_name }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="sendGift" v-if="showPersonGiftCode">
          <input type="text" v-model="personGiftCode" />
          <button
            type="button"
            v-clipboard:copy="personGiftCode"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            复制礼包码
          </button>
        </div>
        <div
          class="tips"
          v-if="
            receiveState &&
            !showPersonGiftCode &&
            personGift.length > 0 &&
            !showPersonGift
          "
        >
          注：礼包发放完毕，请联系客服领取噢~
        </div>
      </div>
      <!-- 队伍总额 -->
      <div class="amountTeam">
        <div class="amount">
          截至目前您的队伍充值总额为：<i>{{ team }}元</i>
        </div>
        <div class="gift" v-if="showTeamGift">
          根据活动规则，您没有获得的返利礼包哦
        </div>
        <div class="gift" v-else>
          根据活动规则，您获得的返利礼包为：<i>{{ teamGiftName }}</i>
        </div>
        <div class="pc">
          <div class="box box-left" v-if="teamGiftIsTure">
            <div class="process" v-for="(item, i) in teamGift" :key="i">
              <div
                class="plan planHide"
                :class="teamGift[i].status ? 'on' : ''"
              ></div>
              <div class="gp">
                <span>
                  <img :src="item.img_url" />
                </span>
                <p>{{ item.gift_name }}</p>
              </div>
            </div>
          </div>
          <div class="box" v-else>
            <div class="process" v-for="(item, i) in teamGift" :key="i">
              <div
                class="plan"
                v-if="teamGift.length == 1"
                :class="teamGift[i].status ? 'on' : ''"
              ></div>
              <div
                class="plan planHide"
                v-else-if="
                  teamGift.length == 3 && teamGift.slice(-2)[0].status == true
                "
                :class="teamGift[i].status ? 'on' : ''"
              ></div>
              <div
                class="plan"
                v-else
                :class="teamGift[i].status ? 'on' : ''"
              ></div>
              <div class="gp">
                <span>
                  <img :src="item.img_url" />
                </span>
                <p>{{ item.gift_name }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="sendGift" v-if="showTeamGiftCode">
          <input type="text" v-model="teamGiftCode" />
          <button
            type="button"
            v-clipboard:copy="teamGiftCode"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            复制礼包码
          </button>
        </div>
        <div
          class="tips"
          v-if="
            receiveState &&
            !showTeamGiftCode &&
            teamGift.length > 0 &&
            !showTeamGift
          "
        >
          注：礼包发放完毕，请联系客服领取噢~
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
export default {
  name: "rebeta",
  props: ["receiveState"],
  data: function () {
    return {
      // 礼包码
      personGiftCode: "Copy These Text",
      showPersonGiftCode: false,
      teamGiftCode: "111",
      showTeamGiftCode: false,
      // 金额
      person: "",
      team: "",
      // 是否获得礼包
      showPersonGift: true,
      showTeamGift: true,
      // 礼包
      personGift: "",
      teamGift: "",
      // 获取可以领取礼包的名字
      personGiftName: "",
      teamGiftName: "",
      // 礼包是否还有库存
      spareGift: false,
      rebetaData: false,
      // 礼包最后一个是否为ture
      personGiftIsTure: false,
      teamGiftIsTure: false,
    };
  },
  methods: {
    hideRebeta() {
      this.$emit("hideRebeta", true);
    },
    onCopy: function () {
      alert("复制成功！");
    },
    onError: function () {
      alert("复制失败，请手动复制");
    },
    // 获取可领取礼包列表
    getGift() {
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.getGift,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            // 个人礼物
            // 礼包列表大于0  this.personGift 个人  this.teamGift 团队
            this.personGift = res.data.data.person_gift;
            this.teamGift = res.data.data.team_gift;

            // 修改礼包向左或者向右展示
            this.personGiftIsTure = this.personGift.slice(-1)[0].status;
            this.teamGiftIsTure = this.teamGift.slice(-1)[0].status;

            // 判断礼包是否符合领取展示  个人
            this.personGift.forEach((item) => {
              if (item.status === true) {
                this.showPersonGift = false;
                this.personGiftName = item.gift_name;
                if (this.receiveState == true) {
                  this.giftReward(2, item.gift_id);
                }
              }
            });

            // 判断礼包是否符合领取展示  团队
            this.teamGift.forEach((item) => {
              if (item.status === true) {
                this.showTeamGift = false;
                this.teamGiftName = item.gift_name;
                if (this.receiveState == true) {
                  this.giftReward(1, item.gift_id);
                }
              }
            });

            // 判断是领取礼包时间
            // if (this.receiveState == true) {
            //   console.log("jinlai");
            //   this.giftReward(2, this.personGift.slice(-1)[0].gift_id);
            //   this.giftReward(1, this.teamGift.slice(-1)[0].gift_id);
            // }

            // 充值金额
            this.payData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查看充值数据接口
    payData() {
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.payData,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            // 个人充值
            this.person = res.data.data.person;
            // 团队充值
            this.team = res.data.data.team;
            // console.log(res);
            this.rebetaData = true;
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 领取礼包接口接口
    giftReward(type, id) {
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        gift_id: id,
        gift_type: type,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.giftReward,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            // 是否是可领取状态
            if (this.receiveState) {
              if (type == 1) {
                // 团队礼包
                // this.teamGiftCode = res.data.data.person;
                this.teamGiftCode = res.data.data;
                if (this.teamGiftCode !== "") {
                  this.showTeamGiftCode = true;
                } else {
                  // 礼包发完了
                  this.showTeamGiftCode = false;
                }
              }
              if (type == 2) {
                // 个人礼包
                // this.personGiftCode = res.data.data.team;
                this.personGiftCode = res.data.data;
                if (this.personGiftCode !== "") {
                  this.showPersonGiftCode = true;
                } else {
                  // 礼包发完了
                  this.showPersonGiftCode = false;
                }
              }
            }
          }
          console.log("失败原因==", res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    console.log("领取状态11===", this.receiveState);
  },
  mounted() {
    this.getGift();
  },
};
</script>
    
<style scoped lang="scss" src="@/sass/rebeta.scss">
</style>